export const data = [
    {
        id: 101,
        title: "Mens Casual T-Shirts",
        price: 22,
        image: "https://fakestoreapi.com/img/71-3HjGNDUL._AC_SY879._SX._UX._SY._UY_.jpg",
        description: {
            category: 'tshirt',
            color: 'grey',
            size: 'L'
        },
        inStock: true,
        quantity: 10
    },
    {
        id: 102,
        title: "Mens Cotton Jacket",
        price: 55,
        image: "https://fakestoreapi.com/img/71li-ujtlUL._AC_UX679_.jpg",
        description: {
            category: 'jacket',
            color: 'brown',
            size: 'L'
        },
        inStock: true,
        quantity: 10
    },
    {
        id: 103,
        title: "Mens Casual Slim Fit",
        price: 16,
        image: "https://fakestoreapi.com/img/71YXzeOuslL._AC_UY879_.jpg",
        description: {
            category: 'tshirt',
            color: 'blue',
            size: 'L'
        },
        inStock: true,
        quantity: 10
    },
    {
        id: 104,
        title: "Women Moto Biker Jacket",
        price: 29,
        image: "https://fakestoreapi.com/img/81XH0e8fefL._AC_UY879_.jpg",
        description: {
            category: 'jacket',
            color: 'black',
            size: 'XL'
        },
        inStock: true,
        quantity: 10
    },
    {
        id: 105,
        title: "Women Rain Jacket",
        price: 40,
        image: "https://fakestoreapi.com/img/71HblAHs5xL._AC_UY879_-2.jpg",
        description: {
            category: 'jacket',
            color: 'blue',
            size: 'L'
        },
        inStock: true,
        quantity: 10
    },
    {
        id: 106,
        title: "MBJ Solid Short",
        price: 10,
        image: "https://fakestoreapi.com/img/71z3kpMAYsL._AC_UY879_.jpg",
        description: {
            category: 'short',
            color: 'white',
            size: 'L'
        },
        inStock: true,
        quantity: 10
    },
    {
        id: 107,
        title: "Opna Women's Short",
        price: 8,
        image: "https://fakestoreapi.com/img/51eg55uWmdL._AC_UX679_.jpg",
        description: {
            category: 'short',
            color: 'Red',
            size: 'MD'
        },
        inStock: true,
        quantity: 10
    },
    {
        id: 108,
        title: "DANVOUY Womens T Shirt",
        price: 13,
        image: "https://fakestoreapi.com/img/61pHAEJ4NML._AC_UX679_.jpg",
        description: {
            category: 'tshirt',
            color: 'Red',
            size: 'MD'
        },
        inStock: true,
        quantity: 10
    },
    {
        id: 109,
        title: "Jogger Pant",
        price: 32,
        image: "https://5.imimg.com/data5/SELLER/Default/2021/2/FQ/AM/RI/28917068/mockup-of-a-man-wearing-sublimated-sweatpants-on-the-street-29848-4--500x500.png",
        description: {
            category: 'pant',
            color: 'black',
            size: 'L'
        },
        inStock: true,
        quantity: 10
    },
    {
        id: 110,
        title: "Casual Pant",
        price: 22,
        image: "https://m.media-amazon.com/images/I/71dFJdQwWCL._UY741_.jpg",
        description: {
            category: 'pant',
            color: 'brown',
            size: 'L'
        },
        inStock: true,
        quantity: 10
    },
    {
        id: 111,
        title: "Mens Jeans Pant",
        price: 5,
        image: "https://www.tradeford.com/pimages/l/1/951351.jpg",
        description: {
            category: 'pant',
            color: 'blue',
            size: 'L'
        },
        inStock: true,
        quantity: 10
    },
]

// https://www.freecodecamp.org/news/how-to-work-with-multiple-checkboxes-in-react/